import { FirebaseOptions, initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const fbConfig: FirebaseOptions = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID,
  measurementId: import.meta.env.VITE_MEASUREMENT_ID
};

const app = initializeApp(fbConfig);

if (import.meta.env.DEV) {
  const appCheckGlobal = globalThis as typeof globalThis & {
    FIREBASE_APPCHECK_DEBUG_TOKEN?: string | boolean;
  };
  const debugToken = import.meta.env.VITE_FIREBASE_APPCHECK_DEBUG_TOKEN?.trim();

  if (debugToken) {
    appCheckGlobal.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
  } else if (appCheckGlobal.FIREBASE_APPCHECK_DEBUG_TOKEN === undefined) {
    appCheckGlobal.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
}

// Constants for key display
const KEY_PREFIX_LENGTH = 5;
const KEY_SUFFIX_LENGTH = -5;

if (!import.meta.env.VITE_RECAPTCHA_KEY) {
  throw new Error("Missing VITE_RECAPTCHA_KEY");
}
console.warn(
  `*****Info: ${import.meta.env.VITE_RECAPTCHA_KEY.slice(0, KEY_PREFIX_LENGTH)}...${import.meta.env.VITE_RECAPTCHA_KEY.slice(KEY_SUFFIX_LENGTH)}`
);
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(import.meta.env.VITE_RECAPTCHA_KEY),
  isTokenAutoRefreshEnabled: true
});

export default app;
